import request from '@/utils/request'

const baseUrl = '/erp/finance/report/expense-detail'

export const pageExpenseDetailReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const exportExpenseDetailReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
